import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import { Modal, Table } from 'react-bootstrap';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import { initialValues, roleTypes } from './Constant';
import { useFormik } from 'formik';
// import { AddRoleVS } from 'shared/utils/validation/SettingValidation';
import { deepCopy, fomatTextCapitalize } from 'shared/utils/Helper';
import RoleCheckBox from 'shared/components/common/role_check_box/RoleCheckBox';
import RoleTable from 'shared/components/common/role_table/RoleTable';
// import { AddRoleMutation, UpdateRoleMutation } from 'shared/services/role_service/RoleService';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { roleTableData } from './Constant';
import Heading from 'shared/components/common/heading/Heading';
import { UpdateRoleMutation } from 'shared/services/role_service/RoleService';
import UploadAvatar from 'shared/components/common/upload_avatar/UploadAvatar';
import { uploadFileMedia } from 'shared/services/media_service/Media_Service';

export default function UserRole({ show, RoleItem, userProfileImg, handleClose }) {
    const [avatarFile, setAvatarFile] = useState(null);
    const [loaderUp, setloaderup] = useState(false);

    const [selectedImg, setSelectedImg] = useState(userProfileImg ? userProfileImg : "");

    const [initiaFormikVal, setInitialFormikVal] = useState(initialValues);
    const [roleAccessList, setRoleAccesstList] = useState(() => deepCopy(roleTableData));
    // const { mutate: addRoleMutate, isLoading: RoleIsLoading, isSuccess: RoleIsSuccess } = AddRoleMutation();
    const { mutate: updateRoleMutate, isLoading: UpdateRoleIsLoading, isSuccess: UpdateRoleIsSuccess } = UpdateRoleMutation();
    console.log(roleAccessList, "roleAccessList");

    useEffect(() => {
        formatRoleToTable(RoleItem);

    }, [RoleItem, show, userProfileImg]);
    useEffect(() => {
        if (UpdateRoleIsSuccess) {
            onClose();
        }
    }, [UpdateRoleIsSuccess]);
    useEffect(() => {
        setSelectedImg(userProfileImg || "");
    }, [userProfileImg]);
    const formatRoleToTable = (roleItem) => {

        if (roleItem) {
            let roles = [];
            let notIncludes = ['_id', '__v', 'name', 'profile_image', 'createdAt', 'updatedAt'];
            Object.entries(roleItem).forEach(([key, value]) => {
                if (!notIncludes.includes(key) && typeof value === 'object' && value !== null) {
                    let valueObj = {
                        ...value,
                        all: value.create && value.delete && value.update && value.view
                    };
                    let obj = {
                        key: key,
                        [key]: valueObj
                    };
                    roles.push(obj);
                }
            });

            setRoleAccesstList(roles);
        } else {
            setRoleAccesstList(roleTableData);
        }
    };
    const resetRole = () => {
        let roles = [];
        roleTableData.map((item) => {
            let obj = {
                ...item,
                key: item.key,
                [item.key]: { all: false, view: false, create: false, update: false, delete: false }
            };
            roles.push(obj);
            return obj;
        });
        setRoleAccesstList(roles);
    };
    const changeTableData = (rolinx, keyName, mutateKey) => {
        let cloneRole = deepCopy(roleAccessList);
        if (mutateKey == 'all') {
            let allkeyValue = !cloneRole[rolinx][keyName][mutateKey];
            cloneRole[rolinx][keyName][mutateKey] = allkeyValue;
            cloneRole[rolinx][keyName].view = allkeyValue;
            cloneRole[rolinx][keyName].create = allkeyValue;
            cloneRole[rolinx][keyName].update = allkeyValue;
            cloneRole[rolinx][keyName].delete = allkeyValue;
        } else {
            cloneRole[rolinx][keyName][mutateKey] = !cloneRole[rolinx][keyName][mutateKey];
        }
        setRoleAccesstList(cloneRole);
    };
    const columns = React.useMemo(
        () => [
            {
                Header: <div>Access Scope</div>,
                accessor: 'teamName',
                Cell: ({ row }) => <div className={classNames(styles.AccessRightMargin)}>{fomatTextCapitalize(row.original.key)}</div>
            },
            {
                Header: <div>ALL</div>,
                accessor: 'all',
                Cell: ({ row }) => (
                    <div className={classNames(styles.TableItemWidth, styles.ColumnLeftPadding, styles.Lead)}>
                        <RoleCheckBox
                            handleClick={() => changeTableData(row.index, row.original.key, 'all')}
                            isActive={row.original[row.original.key].all}
                            CheckboxStyle={classNames(styles.DefaultCheckBox)}
                        />
                    </div>
                )
            },
            {
                Header: <div>View</div>,
                accessor: 'view',
                Cell: ({ row }) => (
                    <div className={classNames(styles.TableItemWidth, styles.ColumnLeftPadding, styles.Lead)}>
                        <RoleCheckBox
                            handleClick={() => changeTableData(row.index, row.original.key, 'view')}
                            isActive={row.original[row.original.key].view}
                            CheckboxStyle={classNames(styles.DefaultCheckBox)}
                        />
                    </div>
                )
            },
            {
                Header: <div>Create</div>,
                accessor: 'create',
                Cell: ({ row }) => {
                    return (
                        <div className={classNames(styles.TableItemWidth, styles.ProjectDateContainer, 'ps-0')}>
                            <RoleCheckBox
                                handleClick={() => changeTableData(row.index, row.original.key, 'create')}
                                isActive={row.original[row.original.key].create}
                                CheckboxStyle={classNames(styles.DefaultCheckBox)}
                            />
                        </div>
                    );
                }
            },
            {
                Header: <div>Update</div>,
                accessor: 'update',
                Cell: ({ row }) => {
                    return (
                        <div className={classNames(styles.TableItemWidth, styles.Manager)}>
                            <RoleCheckBox
                                handleClick={() => changeTableData(row.index, row.original.key, 'update')}
                                isActive={row.original[row.original.key].update}
                                CheckboxStyle={classNames(styles.DefaultCheckBox)}
                            />
                        </div>
                    );
                }
            },
            {
                Header: <div>Delete</div>,
                accessor: 'delete',
                Cell: ({ row }) => {
                    return (
                        <div className={classNames(styles.TableItemWidth, styles.Manager)}>
                            <RoleCheckBox
                                handleClick={() => changeTableData(row.index, row.original.key, 'delete')}
                                isActive={row.original[row.original.key].delete}
                                CheckboxStyle={classNames(styles.DefaultCheckBox)}
                            />
                        </div>
                    );
                }
            }
        ],
        [roleAccessList]
    );
    const onClose = () => {
        resetRole();
        handleClose();
    };
    const uploadMedia = async () => {
        try {
            let fileBody = new FormData();
            fileBody.append('image', avatarFile);

            return await uploadFileMedia(fileBody);
        } catch (error) {
        }
    };
    const roleSubmit = async (values) => {
        let roles = {};

        roleAccessList.map((item) => {
            let obj = {
                ...item[item.key]
            };
            delete obj.all;
            roles[item.key] = obj;
        });

        if (typeof avatarFile !== 'string') {
            if (avatarFile) {
                setloaderup(true)
                let resp = await uploadMedia();
                if (resp?.data) {
                    setloaderup(false)
                    roles['profile_image'] = resp?.data?.url;
                }
            }
        }

        let payload = {
            id: RoleItem?._id,
            body: roles
        };

        updateRoleMutate(payload);
    };

    return (
        <Modal size="lg" show={show} onHide={onClose} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body className={classNames(styles.ModalBody)}>
                <div className={classNames(styles.UserRoleContainer)}>
                    <div className={classNames(styles.UserRoleHeader)}>
                        <Heading heading={RoleItem ? 'Update User Role' : 'Access rights'} headingStyle={classNames(styles.Heading)} />
                    </div>
                    <div className={classNames(styles.ContentContainer)}>
                        <div className={classNames(styles.Content)}>
                            <div className={classNames(styles.LabelStyle)}>Define Role Access</div>
                            <UploadAvatar UploadedFile={avatarFile} setFile={setAvatarFile} selectedImg={selectedImg} setSelectedImg={setSelectedImg} />
                            <RoleTable columns={columns} data={roleAccessList} showPagination={false} />
                        </div>
                        <div className={classNames(styles.BtnContainer, 'd-flex')}>
                            <CustomButton text={'Cancel'} submitHandle={onClose} containerStyle={classNames(styles.Cancel)} />
                            <CustomButton text={RoleItem ? 'Update' : 'Add'} submitHandle={() => roleSubmit()} containerStyle={classNames(styles.Delete)} />
                        </div>
                    </div>
                    {UpdateRoleIsLoading && <OverlayLoading />}
                    {loaderUp && <OverlayLoading />}

                </div>
            </Modal.Body>
        </Modal>
    );
}
